export const vendorTrades = [
    {
        value: "Alarm"
    },
    {
        value: "Security"
    },
    {
        value: "Cleaning"
    },
    {
        value: "Appliances"
    },
];

export const vendors = [
    {
        value: "seerat"
    },
    {
        value: "rimsha"
    },
    {
        value: "aamir"
    },
    {
        value: "kashif"
    },
    {
        value: "akash"
    },
];

export const assignees = [
    "kainat",
    "aamir",
    "rimsha",
    "kashif",
    "akash"
];